import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const data = [['MP', 'María P.', 'Docente de Historia — Lima, Perú', 'Mis alumnos por fin entienden cómo conectar los procesos históricos entre sí. Ahora entro al aula con todo listo y con confianza.'], ['JR', 'Jorge R.', 'Profesor de Historia — Buenos Aires, Argentina', 'El material hace el trabajo pesado por mí. Nunca más llegué a una clase sin saber cómo explicar un período histórico complejo.'], ['CL', 'Claudia L.', 'Docente de nivel medio — Bogotá, Colombia', 'Las secuencias didácticas me ahorran horas. No improviso nunca más frente a mis alumnos.']];
export function TestimonialsStrip() {
  return <section className="border-y border-dark-border bg-dark-card px-4 py-12" data-id="element-195">
      <div className="mx-auto grid max-w-7xl gap-6 md:grid-cols-3" data-id="element-196">
        {data.map(([initials, name, role, text], i) => <motion.article key={name} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.12
      }} className="rounded-2xl border border-gold/20 bg-black p-6" data-id="element-197">
            <div className="mb-4 flex text-gold" data-id="element-198">
              {Array.from({
            length: 5
          }, (_, j) => <Star key={j} size={15} fill="currentColor" data-id="element-199" />)}
            </div>
            <p className="mb-5 text-sm italic leading-relaxed text-gray-300" data-id="element-200">
              “{text}”
            </p>
            <div className="flex items-center gap-3" data-id="element-201">
              <span className="flex h-10 w-10 items-center justify-center rounded-full border border-gold bg-gold/10 text-sm font-bold text-gold" data-id="element-202">
                {initials}
              </span>
              <div data-id="element-203">
                <strong className="block text-sm" data-id="element-204">{name}</strong>
                <span className="text-xs text-gold-light" data-id="element-205">{role}</span>
              </div>
            </div>
          </motion.article>)}
      </div>
    </section>;
}